import Vue from 'vue';
import VueRouter from 'vue-router';
import Inicio from '@/views/Inicio.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Inicio',
    component: Inicio,
  },
  {
    path: '/ayuda',
    name: 'Ayuda',
    component: () => import('@/views/Ayuda.vue'),
  },
  {
    path: '/glosario',
    name: 'Glosario',
    component: () => import('@/views/Glosario.vue'),
  },
  {
    path: '/creditos',
    name: 'Creditos',
    component: () => import('@/views/Creditos.vue'),
  },
  {
    path: '/creditos/:id',
    name: 'Investigadores',
    component: () => import('@/views/Investigadorxs.vue'),
    props: true
  },
  {
    path: '/guia-estilos',
    name: 'Guia de Estilos',
    component: () => import('@/views/GuiaEstilos.vue'),
  },
  {
    path: '/electricidad',
    name: 'Electricidad',
    component: () => import('@/views/Electricidad/Electricidad.vue'),
  },
  {
    path: '/electricidad/sistema-electrico-nacional',
    name: 'Sistema Electrico',
    component: () => import('@/views/Electricidad/SistemaElectrico.vue'),
  },
  {
    path: '/electricidad/balance-electricidad',
    name: 'Balance Electricidad',
    component: () => import('@/views/Electricidad/BalanceElectricidad.vue'),
  },
  {
    path: '/electricidad/generacion',
    name: 'Generacion',
    component: () => import('@/views/Electricidad/Generacion.vue'),
  },
  {
    path: '/electricidad/demanda',
    name: 'DemandaElectricidad',
    component: () => import('@/views/Electricidad/Demanda.vue'),
  },
  {
    path: '/electricidad/transmision',
    name: 'Transmision',
    component: () => import('@/views/Electricidad/Transmision.vue'),
  },
  {
    path: '/electricidad/acceso',
    name: 'Acceso',
    component: () => import('@/views/Electricidad/Acceso.vue'),
  },
  {
    path: '/electricidad/relacion-socioeconomica',
    name: 'Relacion Socioeconomica',
    component: () => import('@/views/Electricidad/RelacionSocioeconomica.vue'),
  },
  {
    path: '/electricidad/relacion-socioecologica',
    name: 'Relacion Socioecologica',
    component: () => import('@/views/Electricidad/RelacionSocioecologica.vue'),
  },
  {
    path: '/hidrocarburos',
    name: 'Hidrocarburos',
    component: () => import('@/views/Hidrocarburos/Hidrocarburos.vue'),
  },
  {
    path: '/hidrocarburos/historia-hidrocarburos',
    name: 'HistoriaHidrocarburos',
    component: () => import('@/views/Hidrocarburos/HistoriaHidrocarburos.vue'),
  },
  {
    path: '/hidrocarburos/demanda',
    name: 'DemandaHidrocarburos',
    component: () => import('@/views/Hidrocarburos/Demanda.vue'),
  },
  {
    path: '/hidrocarburos/reservas-crudo',
    name: 'ReservasCrudo',
    component: () => import('@/views/Hidrocarburos/ReservasCrudo.vue'),
  },
  {
    path: '/hidrocarburos/reservas-gas',
    name: 'ReservasGas',
    component: () => import('@/views/Hidrocarburos/ReservasGas.vue'),
  },
  {
    path: '/hidrocarburos/produccion-crudo',
    name: 'ProduccionCrudo',
    component: () => import('@/views/Hidrocarburos/ProduccionCrudo.vue'),
  },
  {
    path: '/hidrocarburos/produccion-gas',
    name: 'ProduccionGas',
    component: () => import('@/views/Hidrocarburos/ProduccionGas.vue'),
  },
  {
    path: '/hidrocarburos/flujo-gas',
    name: 'FlujoGas',
    component: () => import('@/views/Hidrocarburos/FlujoGas.vue'),
  },
  {
    path: '/hidrocarburos/refinacion-distribucion',
    name: 'Infraestructura',
    component: () => import('@/views/Hidrocarburos/Infraestructura.vue'),
  },
  {
    path: '/biomasa',
    name: 'Biomasa',
    component: () => import('@/views/Biomasa/Biomasa.vue'),
  },
  {
    path: '/biomasa/estado-actual',
    name: 'BiomasaEstadoActual',
    component: () => import('@/views/Biomasa/EstadoActual.vue'),
  },
  {
    path: '/biomasa/estado-actual2',
    name: 'BiomasaEstadoActual',
    component: () => import('@/views/Biomasa/EstadoActual2.vue'),
  },
  {
    path: '/biomasa/demanda',
    name: 'BiomasaDemanda',
    component: () => import('@/views/Biomasa/Demanda.vue'),
  },
  {
    path: '/biomasa/oferta',
    name: 'BiomasaOferta',
    component: () => import('@/views/Biomasa/Oferta.vue'),
  },
  {
    path: '/biomasa/balance',
    name: 'BiomasaBalanceOfertaDemanda',
    component: () => import('@/views/Biomasa/Balance.vue'),
  },
  {
    path: '/balance',
    name: 'Introduccion',
    component: () => import('@/views/Balance/Introduccion.vue'),
  },
  {
    path: '/balance/produccion',
    name: 'BalanceProduccion',
    component: () => import('@/views/Balance/Produccion.vue'),
  },
  {
    path: '/balance/transformaciones-principales',
    name: 'Transformaciones',
    component: () => import('@/views/Balance/Transformaciones.vue'),
  },
  {
    path: '/balance/comercio-exterior',
    name: 'ComercioExterior',
    component: () => import('@/views/Balance/ComercioExterior.vue'),
  },
  {
    path: '/balance/consumo-final',
    name: 'ConsumoFinal',
    component: () => import('@/views/Balance/ConsumoFinal.vue'),
  },
  {
    path: '/balance/balance-energia',
    name: 'BalanceEnergia',
    component: () => import('@/views/Balance/BalanceEnergia.vue'),
  },
  {
    path: '**',
    name: 'Página no encontrada',
    component: () => import('@/views/404.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0, behavior: 'smooth' };
  },
});

export default router;
